module.exports = __webpack_public_path__ + "static/media/transparent_logo_cropped.606c0fc4.png";